export default "__VITE_ASSET__BJxv4FAj__"